<ul class="tab-bar" [ngClass]="tab_bar_css_class">
	<li
		*ngFor="let t of tabs; let i = index"
		[ngStyle]="{ width: align === 'justify' ? 100 / tabs.length + '%' : 'auto' }"
	>
		<a *ngIf="!route_tabs" #tab (click)="showTab(i)" [ngClass]="{ active: selected_tab.index === i }">
			<i class="icon-tick" *ngIf="check_tabs"></i>
			<span class="text">{{ t.name }}</span>
		</a>
		<a *ngIf="route_tabs" #tab [routerLink]="[t.route]" routerLinkActive="active">
			<i class="icon-tick" *ngIf="check_tabs"></i>
			<span class="text">{{ t.name }}</span>
		</a>
	</li>
	<li
		class="highlight sec-bg"
		[ngClass]="{ static: highlight_static }"
		[ngStyle]="{
			left: selected_tab.left + 'px',
			width: selected_tab.width + 'px'
		}"
	></li>
</ul>
